import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import '../../../stylesheet/transactionReport.css'
import { IPickupFeesReportModel } from '../core/_models'
import PickupFeesReportTableRow from './PickupFeesReportTableRow'
import {storeCurrencyLabel} from '../../common/currencyLabel'

interface ITotalPickupFeesRow {
    total_pickups_count: number
    total_pickups_fees: number
}

interface IProps {
    data: IPickupFeesReportModel[]
    pickupFeesTotal?: ITotalPickupFeesRow | null
}

const PickupFeesReportTable: FC<IProps> = ({ data, pickupFeesTotal }) => {
    const { formatMessage } = useIntl()

    return (
            <table className="table align-middle gs-0 gy-5">
                <thead>
                <tr>
                    <th scope="col" className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({ id: 'supplier_name' })}
                    </th>
                    <th scope="col" className="fw-bold p-0 px-2 text-uppercase">
                        {formatMessage({ id: 'po_id' })}
                    </th>
                    <th scope="col" className="fw-bold p-0 px-2 text-uppercase">
                        {formatMessage({ id: 'fees' })}
                    </th>
                    <th scope="col" className="fw-bold p-0 px-2 text-nowrap text-uppercase">
                        {formatMessage({ id: 'date_added' })}
                    </th>
                </tr>
                </thead>
                <tbody>
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <PickupFeesReportTableRow key={`${item.delivery_fee_id}-${index}`} item={item} />
                    ))
                ) : (
                    <tr>
                        <td colSpan={6} className="text-center">
                            {formatMessage({ id: 'no_data_available' })}
                        </td>
                    </tr>
                )}
                {pickupFeesTotal && (
                    <tr>

                        <td></td>
                        <td></td>
                        <td className="fw-bold text-end td-border">
                            {formatMessage({id: 'pickups_fees'})}
                        </td>
                        <td className="green-text td-border">
                            {pickupFeesTotal.total_pickups_fees} {storeCurrencyLabel(formatMessage)}
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                )}
                </tbody>
            </table>
    )
}

export default PickupFeesReportTable
